import React = require('react');
import MuiTextField from "material-ui/TextField";

interface TextFieldProps extends __MaterialUI.TextFieldProps {
    focusOnMount?: boolean;
}

export default class TextField extends React.Component<TextFieldProps, {}> {

    private textField: MuiTextField;

    getStyles() {
        return {
            textField: {
                border: "1px solid",
                width: "100%",
                padding: "0 15px 0 15px"
            },
            underline: {
                display: "none"
            },
        };
    }

    render() {
        const styles = this.getStyles();
        const props: TextFieldProps = {...this.props};
        delete props.focusOnMount;
        if (this.props.multiLine) {
            props.style = Object.assign({}, styles.textField, this.props.style);
            props.underlineStyle =  Object.assign({}, styles.underline, this.props.underlineStyle);
        }

        return (
            <MuiTextField
                ref={(textField: MuiTextField) => {this.textField = textField; }}
                {...props}
            />
        );
    }

    componentDidMount () {
        if (this.props.focusOnMount) {
            // XXX because we may be in an event loop
            // we need to schedule focus afterwards
            // so that focus would not be stolen by another event
            setTimeout(this.textField.focus, 0);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/custom-components/TextField/TextField.tsx
 **/